import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/shared/services/session.service';

@Injectable({
  providedIn: 'root',
})
export class ActiveSessionGuard  {
  constructor(private session: SessionService, private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const activeSeesion: boolean = Boolean(this.session.getToken());
    /*if (!activeSeesion) {
      this.router.navigate(['session']);
    }*/
    return activeSeesion;
  }
}
